var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'desktop': _vm.isPc},attrs:{"id":"default-layout"}},[(_vm.isOlakkDesktop)?_c('div',[_c('olakkDesktop')],1):(_vm.isCanada)?_c('canadaView'):(_vm.isEuropean)?_c('euView'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }